import { isEUpilot, isEUprod } from './isNotProd';

const KM_MILE_RATIO = 1.60934;

const convertSpeedToMpH = (metersPerSecond: number) => +(metersPerSecond * 2.237).toFixed(1); // constant has taken from google
const convertSpeedFromMpH = (milesPerHour: number) => +(milesPerHour / 2.237).toFixed(5); // constant has taken from google

export const getLocalSpeedUnit = (): 'mph' | 'kph' => {
  const usesKph = isEUpilot() || isEUprod();

  return usesKph ? 'kph' : 'mph';
};

export const localizeSpeed = (input?: number, sourceUnit?: 'mph' | 'kph' | 'ms'): string => {
  const targetUnit = getLocalSpeedUnit();

  if (sourceUnit === undefined || input === undefined) {
    return '-';
  }

  let inputInMs = 0;

  if (sourceUnit === 'ms') {
    inputInMs = input;
  } else if (sourceUnit === 'mph') {
    inputInMs = convertSpeedFromMpH(input);
  } else if (sourceUnit === 'kph') {
    inputInMs = convertSpeedFromMpH(input / KM_MILE_RATIO);
  }

  if (targetUnit === 'mph') {
    return `${convertSpeedToMpH(inputInMs)} mph`;
  }

  return `${(inputInMs * 3.6).toFixed(1)} kph`;
};

export const convertFromLocalToMeterPerSecond = (input: number): number => {
  const localUnit = getLocalSpeedUnit();
  if (localUnit === 'mph') {
    return convertSpeedFromMpH(input);
  }
  return convertSpeedFromMpH(input / KM_MILE_RATIO);
};

export const localizeDistance = (input?: number, sourceUnit?: 'm' | 'km'): string => {
  const localUnit = getLocalSpeedUnit();

  if (sourceUnit === undefined || input === undefined) {
    return '-';
  }

  const distanceInMeters = sourceUnit === 'km' ? input * 1000 : input;

  if (localUnit === 'mph') {
    return `${(distanceInMeters * 3.28084).toFixed(1)} ft`;
  }

  if (distanceInMeters < 1000) {
    return `${distanceInMeters.toFixed(1)} m`;
  }

  return `${(distanceInMeters / 1000).toFixed(1)} km`;
};
